import Container from '../../components/container';
import fetch from "isomorphic-fetch";
import config from "../../config.json";
import Detalle from '../../components/detalle';
import { withIronSession } from "next-iron-session";
import Whatsapp from "../../components/whatsapp";
import ProductJsonLd from "../../components/product-json-ld";
import Static from "../../config-static.json";

const Product = ({data, coverage, menu, cart, delivery})=>{
    const meta = (data?.nombre) ? <>
        <meta property="og:type" content="og:product"/>
        <meta property="og:title" content={`${data.nombre}, Florería Detalles y Caprichos`}/>
        <meta property="og:image" content={data.fotos[0].url}/>
        <meta property="og:description" content={data.descripciontxt + '|' + Static.seo.description}/>
        <meta name="description" content={data.descripciontxt + '|' + Static.seo.description}/>
        <meta property="og:url" content={`https://arreglos-florales.com/producto/${data.uri}`}/>
        <meta property="product:plural_title" content={`${data.nombre}, Florería Detalles y Caprichos`}/>
        <meta property="product:price:currency" content="MXN"/>
        <meta property="product:price:amount" content={data.price.precio}/>
        <meta name="robots" content="index, follow"/>
        <meta name="publisher" content={Static.seo.publisher}/>
        <meta name="keywords" content={Static.seo.keywords}/>
        <link rel="canonical" href={`https://arreglos-florales.com/producto/${data.uri}`}/>
    </> : null;
    return (
        <>
            <Container title={`${data.nombre}, Florería Detalles y Caprichos`} menu={menu} noNewsletter={true} meta={meta} hiddenMobile={true}>
                <Detalle data={data} coverage={coverage} cart={cart} delivery={delivery}/>
                <ProductJsonLd data={data} />
            </Container>
            <Whatsapp/>
        </>
    );
};

export const getServerSideProps = withIronSession(
    async ( ctx) => {
        const res = await fetch(`${config.api.uri}/v1/product/${ctx.query.id.split('-').pop()}?apikey=${config.api.apikey}&partner=1`); // TODO: partner id was hardcoded
        const resCoverage = await fetch(`${config.api.uri}/v1/partner/coverage/global?apikey=${config.api.apikey}`);
        const resJSON = await res.json();
        const resJSONCoverage = await resCoverage.json();
        const resMenu = await fetch(`${config.api.uri}/v1/cat/menu/1?apikey=${config.api.apikey}`);
        const resJSONMenu = await resMenu.json();
        const cart = await ctx.req.session.get("cart");
        const delivery = await ctx.req.session.get("delivery");
        if(resJSON?.id_producto){
            return {
                props: {
                    data: resJSON,
                    coverage: resJSONCoverage,
                    menu: resJSONMenu,
                    cart: (cart) ? cart : null,
                    delivery: (delivery) ? delivery : null
                }
            }
        }else{
            return {
                notFound: true
            }
        }
    },{
        password: config.cookie.signature,
        cookieName: config.cookie.name,
        cookieOptions: {
            secure: config.cookie.secure
        }
    }
);

export default Product;
